import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import location_icon from '../../../assets/location_icon.svg';
import people_icon from '../../../assets/people_icon.svg';
import {
  AddBtn,
  Add,
  Card,
  Container,
  Header,
  StoreImage,
  StoreName,
  HeaderDetailContainer,
  DetailsContainer,
  StoreLocation,
  HeaderIcon,
  Row,
  Title,
  SectionHeader,
  SectionDetails,
  EmptyState,
  EmptyTxt,
  CustomAgentCard,
  EditBtn,
  InfoCards,
  InfoTitle,
  InfoValue,
  SearchContainer,
  SearchIcon,
  SearchBar,
  SearchWrapper
} from './styles';
import {
  useDeleteStoreProductMutation,
  useGetProductsByStoreIdQuery,
  useGetStoreByIdQuery
} from '../../../store/shopping/api';
import { IStore, IStoreProduct } from '../../../store/shopping/interface';
import { Loader } from '../../../component/loader';
import { StoreProduct } from './storeProducts';
import { RoomTypeContainer } from '../../hotel/viewHotel/style';
import { AddProducts } from '../compoonents/storeModals/addProduct';
import { EditStore } from '../compoonents/storeModals/editStore';
import { RightAsideSection } from '../../home/styles';
import { DeleteModal } from '../../../component/modal/deleteModal';
import { showSuccessToast, showErrorToast } from '../../../utils/toast';
import { EditProduct } from '../compoonents/storeModals/editProduct';
import { AddProductList } from '../compoonents/storeModals/addProductList';
import { generateUrl } from '../../../utils/urlGenerator';
import { Paginate } from '../../../component/pagenate';
import useDebounce from '../../../utils/useDebounce';
import searchIcon from '../../../assets/Search.svg';

export const ViewStores = () => {
  const { state } = useLocation();
  const [storeId] = useState((state as { storeId: string }).storeId);
  const [store, setStore] = useState<IStore>();
  const [pageNumber, setPageNumber] = useState(1);
  const [showAddProducts, setShowAddProducts] = useState<number | null>(null);
  const [editStoreModal, setEditStoreModal] = useState(false);
  const [deleteProduct, setDeleteProduct] = useState<string | null>(null);
  const [editProduct, setEditProduct] = useState<IStoreProduct | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const debounceSearchProducts = useDebounce(searchValue, 500);

  const productDetails = useMemo(
    () =>
      generateUrl({
        storeId,
        pageSize: 6,
        pageNo: pageNumber,
        search: debounceSearchProducts
      }),
    [debounceSearchProducts, pageNumber, storeId]
  );
  const { data: storeData, isLoading: isStoreDataLoading } =
    useGetStoreByIdQuery(storeId);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const { data: storeProducts, isFetching: isProductsLoading } =
    useGetProductsByStoreIdQuery(productDetails);

  const [deleteStoreProduct, { isLoading: isDeleting }] =
    useDeleteStoreProductMutation();

  const handleEditStore = () => {
    setEditStoreModal(true);
  };

  const handleDeleteStoreProduct = (storeId: string) => {
    setDeleteProduct(storeId);
  };

  const handleStoreProductDelete = () => {
    deleteStoreProduct(deleteProduct!)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeleteProduct(null);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  useEffect(() => {
    if (storeData) {
      setStore(storeData.data);
    }
  }, [storeData]);

  return (
    <Container>
      {(isStoreDataLoading || isProductsLoading) && <Loader />}
      {showAddProducts === 0 && (
        <AddProducts storeId={store?._id ?? ''} setShow={setShowAddProducts} />
      )}
      {showAddProducts === 1 && (
        <AddProductList
          storeId={store?._id ?? ''}
          setShow={setShowAddProducts}
        />
      )}
      {editStoreModal && store && (
        <EditStore storeDetails={store} setShow={setEditStoreModal} />
      )}
      {editProduct && (
        <EditProduct product={editProduct} setShow={setEditProduct} />
      )}
      {deleteProduct && (
        <DeleteModal
          deleteBtnClick={handleStoreProductDelete}
          isLoading={isDeleting}
          cancelBtnClick={() => setDeleteProduct(null)}
          deleteTitle="Delete product"
          deleteText={`Are you sure you want to delete this producte from ${
            store!.name
          }, this action can’t be undone?`}
        />
      )}
      <Header>
        <Title>Store</Title>
        <Row>
          <Add
            options={['Add product', 'Upload product list']}
            value={'Add Product'}
            onSelect={(_value, index) => setShowAddProducts(index)}
          />
          <EditBtn onClick={() => handleEditStore()}>Edit Store</EditBtn>
        </Row>
      </Header>
      {store && (
        <Row>
          <Card>
            <StoreImage images={store?.file ?? []} />
            <DetailsContainer>
              <StoreName>{store.name}</StoreName>
              <Row>
                <HeaderDetailContainer>
                  <HeaderIcon src={location_icon} />
                  <StoreLocation>{`${store?.state}, Nigeria`}</StoreLocation>
                </HeaderDetailContainer>
                <HeaderDetailContainer>
                  <HeaderIcon src={people_icon} />
                  <StoreLocation>{`${store.totalNoumberOfOrders} Orders`}</StoreLocation>
                </HeaderDetailContainer>
              </Row>
              <SectionHeader>Address</SectionHeader>
              <SectionDetails>{store.address}</SectionDetails>
              <SearchWrapper>
                <SectionHeader>Products</SectionHeader>
                <SearchContainer>
                  <SearchIcon src={searchIcon} alt="" />
                  <SearchBar
                    type={'text'}
                    placeholder=" Search for Item"
                    onChange={handleSearchChange}
                    value={searchValue}
                  />
                </SearchContainer>
              </SearchWrapper>
              {!storeProducts?.data.fetchedData?.length ? (
                <EmptyState>
                  <EmptyTxt>
                    No products added, click on the button below to add products
                  </EmptyTxt>
                  <AddBtn onClick={() => setShowAddProducts(0)}>
                    Add Products
                  </AddBtn>
                </EmptyState>
              ) : (
                <RoomTypeContainer>
                  {storeProducts?.data.fetchedData.map((product) => (
                    <StoreProduct
                      key={product._id}
                      product={product}
                      handleEdit={setEditProduct}
                      handleDeleteStoreProduct={handleDeleteStoreProduct}
                    />
                  ))}
                </RoomTypeContainer>
              )}
            </DetailsContainer>
            {!!storeProducts?.data.fetchedData.length && (
              <Paginate
                pageNo={storeProducts.data.pageNo}
                noOfPages={storeProducts.data.noOfPages}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
            )}
          </Card>
          <RightAsideSection>
            {store?.agent && <CustomAgentCard hideDelete agent={store.agent} />}
            <InfoCards>
              <InfoTitle>Products</InfoTitle>
              <InfoValue>{storeProducts?.data.totalCount ?? 0}</InfoValue>
            </InfoCards>
            <InfoCards>
              <InfoTitle>Orders</InfoTitle>
              <InfoValue>{store?.totalNoumberOfOrders}</InfoValue>
            </InfoCards>
            <InfoCards>
              <InfoTitle>Sales</InfoTitle>
              <InfoValue>{store?.totalNoumberOfSales}</InfoValue>
            </InfoCards>
          </RightAsideSection>
        </Row>
      )}
    </Container>
  );
};
